
import Footer from "./Footer";import { useTranslation } from 'react-i18next';


const NAVBAR_HEIGHT = 80;

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-purple-100">

      {/* ================= FEATURES SECTION ================= */}
      <section
        className="relative overflow-hidden"
        style={{ paddingTop: NAVBAR_HEIGHT }}
      >
        {/* SOFT BACKGROUND WITH GRID PATTERN */}
        <div className="absolute inset-0 pointer-events-none">
          {/* Base gradient */}
          <div className="absolute inset-0 bg-gradient-to-b from-white/85 via-white/75 to-white/90" />

          {/* Subtle grid pattern */}
          <div
            className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage: `
                linear-gradient(to right, #7c3aed 1px, transparent 1px),
                linear-gradient(to bottom, #7c3aed 1px, transparent 1px)
              `,
              backgroundSize: "40px 40px",
            }}
          />

          {/* Accent glows */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(124,58,237,0.12),transparent_55%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(99,102,241,0.12),transparent_55%)]" />
        </div>


        <div className="relative container mx-auto px-4 py-12">

          {/* HEADER */}
          <div className="max-w-3xl mb-16">
            <p
              className="
                inline-block text-sm uppercase tracking-widest
                bg-gradient-to-r from-purple-100 via-purple-50 to-indigo-100
                px-4 py-1.5 rounded-full
                font-semibold text-purple-700 mb-4
              "
            >
              Platform Features
            </p>

            <h1 className="text-4xl md:text-4xl font-semibold text-gray-800 leading-tight">
              Features That Power Your Growth
            </h1>

            <p className="mt-5 text-md text-gray-600 leading-relaxed">
              Everything you need to manage logistics, inventory, automation,
              and reporting — built on a modern, scalable platform designed for
              growing businesses.
            </p>
          </div>

          {/* FEATURES GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">

            {[
              {
                title: "All-in-One Platform",
                desc: "Manage logistics, inventory, attendance, automation, and integrations from a single dashboard.",
                img: "/images/feature-1.png",
              },
              {
                title: "Real-Time Dashboards & MIS",
                desc: "Track shipments, stock levels, performance, and insights in real time.",
                img: "/images/feature-2.png",
              },
              {
                title: "Smart Automation & Integrations",
                desc: "Automate workflows using WhatsApp, GPS, APIs, and webhooks.",
                img: "/images/feature-3.png",
              },
              {
                title: "Mobile-Friendly & Easy to Use",
                desc: "Designed for speed, clarity, and smooth usage across all devices.",
                img: "/images/feature-4.png",
              },
              {
                title: "Customizable & Scalable",
                desc: "Choose only the modules you need and scale as your business grows.",
                img: "/images/feature-5.png",
              },
              {
                title: "Dedicated Support & Onboarding",
                desc: "Quick setup, guided onboarding, and responsive support when you need it.",
                img: "/images/feature-6.png",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="
                  group relative
                  rounded-xl p-6
                  bg-white/70 backdrop-blur-md
                  border border-purple-100
                  shadow-lg
                  transition-all duration-300
                  hover:-translate-y-2 hover:shadow-xl
                "
              >
                {/* IMAGE */}
                <div className="mb-6 rounded-xl overflow-hidden bg-white">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="
                      w-full h-[200px] object-cover
                      transition-transform duration-300
                      group-hover:scale-[1.05]
                    "
                  />
                </div>

                {/* TITLE */}
                <h3 className="text-xl font-semibold text-gray-800 mb-3 
 relative block text-2xl font-semibold
 bg-gradient-to-r from-pink-800 via-purple-600 to-indigo-600
 bg-clip-text text-transparent
 pb-4
 after:content-['']
 after:absolute after:left-0 after:bottom-0
 after:h-[1px] after:w-full
 after:bg-gradient-to-r after:from-purple-300 after:to-white
 ">
                  {item.title}
                </h3>

                {/* DESCRIPTION */}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
